// import { useEffect, useState } from 'react'
// import SupportBlock from './SupportBlock/SupportBlock'
// import HeaderEngineering from '../../Modules/HeaderEngineering/HeaderEngineering'
// import AuthBlock from './AuthBlock/AuthBlock'
//
// const SupportPage = () => {
//   const [isAuthenticated, setIsAuthenticated] = useState(false)
//
//   useEffect(() => {
//     const data = localStorage.getItem('authData')
//     if (data) {
//       const { timestamp } = JSON.parse(data)
//       const now = Date.now()
//       const hoursPassed = (now - timestamp) / (1000 * 60 * 60)
//
//       if (hoursPassed < 24) {
//         setIsAuthenticated(true)
//       } else {
//         localStorage.removeItem('authData')
//       }
//     }
//   }, [])
//
//   const handleAuthSuccess = () => {
//     localStorage.setItem('authData', JSON.stringify({ timestamp: Date.now() }))
//     setIsAuthenticated(true)
//   }
//
//   return (
//     <div>
//       <HeaderEngineering />
//       {!isAuthenticated ? (
//         <AuthBlock onAuthSuccess={handleAuthSuccess} />
//       ) : (
//         <SupportBlock />
//       )}
//     </div>
//   )
// }
//
// export default SupportPage

import { useEffect, useState } from 'react'
import SupportBlock from './SupportBlock/SupportBlock'
import HeaderEngineering from '../../Modules/HeaderEngineering/HeaderEngineering'
import AuthBlock from './AuthBlock/AuthBlock'

const SupportPage = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [customerData, setCustomerData] = useState(null)

  useEffect(() => {
    const data = localStorage.getItem('authData')
    if (data) {
      const { timestamp, customer } = JSON.parse(data)
      const now = Date.now()
      const hoursPassed = (now - timestamp) / (1000 * 60 * 60)
      if (hoursPassed < 24) {
        setIsAuthenticated(true)
        setCustomerData(customer)
      } else {
        localStorage.removeItem('authData')
      }
    }
  }, [])

  const handleAuthSuccess = (customer) => {
    localStorage.setItem(
      'authData',
      JSON.stringify({
        timestamp: Date.now(),
        customer: customer,
      }),
    )
    setIsAuthenticated(true)
    setCustomerData(customer)
  }

  return (
    <div>
      <HeaderEngineering />
      {!isAuthenticated ? (
        <AuthBlock onAuthSuccess={handleAuthSuccess} />
      ) : (
        <SupportBlock customerData={customerData} />
      )}
    </div>
  )
}

export default SupportPage
